export var MediaItemType;
(function (MediaItemType) {
    MediaItemType["image"] = "image";
    MediaItemType["video"] = "video";
    MediaItemType["audio"] = "audio";
    MediaItemType["document"] = "document";
    MediaItemType["zip"] = "zip";
})(MediaItemType || (MediaItemType = {}));
export var CouponType;
(function (CouponType) {
    CouponType["BuyXGetY"] = "BuyXGetY";
    CouponType["FixedPrice"] = "FixedPrice";
    CouponType["FreeShipping"] = "FreeShipping";
    CouponType["MoneyOff"] = "MoneyOff";
    CouponType["PercentOff"] = "PercentOff";
})(CouponType || (CouponType = {}));
//# sourceMappingURL=defenitions.js.map